export default __webpack_public_path__ + "static/media/notifications.fcf00b5e.svg";